export default function priceFormatter(price) {
    if (price === '$.99') return '$0.99';
    return price
}